import React from 'react';
import Modal from '../../../../components/Modal';
import { CheckCircle } from 'lucide-react';

interface PrerequisiteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  prerequisiteContent: string;
  wheelName: string;
}

const PrerequisiteModal: React.FC<PrerequisiteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  prerequisiteContent,
  wheelName
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Pré-requisito para Participar do Sorteio"
      size="lg"
    >
      <div className="space-y-4">
        <div className="bg-orange-50 border border-orange-200 rounded-md p-4">
          <p className="text-sm text-orange-800">
            Antes de participar do sorteio "<strong>{wheelName}</strong>", você precisa confirmar que cumpriu o seguinte pré-requisito:
          </p>
        </div>

        <div className="prose prose-sm max-w-none bg-gray-50 rounded-md p-4">
          <div
            className="text-gray-700"
            dangerouslySetInnerHTML={{ __html: prerequisiteContent }}
          />
        </div>

        <div className="flex flex-col sm:flex-row justify-end gap-3 pt-4 border-t">
          <button
            onClick={() => {
                window.close();
            }}
            className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="w-full sm:w-auto px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 font-medium flex items-center justify-center space-x-2"
          >
            <CheckCircle className="h-4 w-4" />
            <span>Confirmo que cumpri o pré-requisito</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PrerequisiteModal;
